import { render, staticRenderFns } from "./BrunetteCircle.vue?vue&type=template&id=366702e8&"
import script from "./BrunetteCircle.vue?vue&type=script&lang=ts&"
export * from "./BrunetteCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports